import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Drawer from '@mui/material/Drawer';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Pages/Common/common.css'

import settings from '../assets/settings.svg'
import Dashboard from '../assets/Dashboard.svg'
import template from '../assets/template-alt.svg'
import Order from '../assets/Order.svg'
import userlock from '../assets/user-lock.svg'
import templateBanner from '../assets/template-alt.svg'
import logout from '../assets/sign-out-alt.svg'

const drawerWidth = '280px';

const AppBar = styled('div')(({ theme }) => ({
  backgroundColor: '#ffffff',
  boxShadow: 'rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorsetting, setanchorsetting] = useState(null);
  
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const settingMenuOpen = (event) => setanchorsetting(event.currentTarget);
  const settingMenuClose = () => setanchorsetting(null);
  
  const HandleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Box sx={{ display: 'flex', height: '100vh' }}>
        <CssBaseline />
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { 
              width: drawerWidth, 
              boxSizing: 'border-box',
              backgroundColor: 'var(--bg-card)',
              borderRight: '1px solid var(--border-light)',
              boxShadow: 'var(--shadow-sm)'
            },
          }}
        >
          <Toolbar className="sidebar-header">
            <div className="pharmacy-logo">
              <div className="logo-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="rgba(255, 255, 255, 0.9)"/>
                  <path d="M2 17L12 22L22 17" stroke="rgba(255, 255, 255, 0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="rgba(255, 255, 255, 0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="7" r="2" fill="rgba(255, 255, 255, 0.8)"/>
                </svg>
              </div>
              <div className="logo-text">
                <h3>E-Commerce</h3>
                <p>Management System</p>
              </div>
            </div>
          </Toolbar>
          
          <div className="sidebar-content">
            <div className="nav-section">
              <h4 className="nav-section-title">Overview</h4>
              <List className="nav-list">
                <ListItem onClick={() => navigate('/Home/Dashboard')} disablePadding>
                  <Tooltip title="Dashboard" placement="right">
                    <ListItemButton 
                      className={`nav-item ${isActive('/Home/Dashboard') || isActive('/Home/ECommerce-Dashboard') ? 'active' : ''}`}
                    >
                      <ListItemIcon className="nav-icon">
                        <img src={Dashboard} alt="dashboard" width="20" height="20"/>
                      </ListItemIcon>
                      <span className="nav-label">Dashboard</span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              </List>
            </div>

            <div className="nav-section">
              <h4 className="nav-section-title">E-commerce Management</h4>
              <List className="nav-list">
                <ListItem onClick={() => navigate('/Home/ECommerce-Dashboard')} disablePadding>
                  <Tooltip title="E-commerce Dashboard" placement="right">
                    <ListItemButton
                      className={`nav-item ${isActive('/Home/ECommerce-Dashboard') ? 'active' : ''}`}
                    >
                      <ListItemIcon className="nav-icon">
                        <img src={Dashboard} alt="e-commerce dashboard" width="20" height="20"/>
                      </ListItemIcon>
                      <span className="nav-label">E-commerce Dashboard</span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
                <ListItem onClick={() => navigate('/Home/Admin-Products')} disablePadding>
                  <Tooltip title="Product Management" placement="right">
                    <ListItemButton
                      className={`nav-item ${isActive('/Home/Admin-Products') ? 'active' : ''}`}
                    >
                      <ListItemIcon className="nav-icon">
                        <img src={template} alt="product management" width="20" height="20"/>
                      </ListItemIcon>
                      <span className="nav-label">Product Management</span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
                <ListItem onClick={() => navigate('/Home/Admin-Orders')} disablePadding>
                  <Tooltip title="Order Management" placement="right">
                    <ListItemButton
                      className={`nav-item ${isActive('/Home/Admin-Orders') ? 'active' : ''}`}
                    >
                      <ListItemIcon className="nav-icon">
                        <img src={Order} alt="order management" width="20" height="20"/>
                      </ListItemIcon>
                      <span className="nav-label">Order Management</span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              </List>
            </div>

            <div className="nav-section">
              <h4 className="nav-section-title">Administration</h4>
              <List className="nav-list">
                <ListItem onClick={settingMenuOpen} disablePadding>
                  <Tooltip title="System Settings" placement="right">
                    <ListItemButton className="nav-item">
                      <ListItemIcon className="nav-icon">
                        <img src={settings} alt="settings" width="20" height="20"/>
                      </ListItemIcon>
                      <span className="nav-label">System Settings</span>
                      <span className="nav-arrow">▼</span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              </List>
            </div>
          </div>

          <div className="sidebar-footer">
            <div className="user-profile">
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'var(--primary-color)' }}>
                U
              </Avatar>
              <div className="user-info">
                <p className="user-name">Admin User</p>
                <p className="user-role">Administrator</p>
              </div>
            </div>
            <button className="logout-btn" onClick={HandleLogout}>
              <img src={logout} alt="logout" width="16" height="16"/>
              Logout
            </button>
          </div>

          <Menu 
            className='settings-menu' 
            anchorEl={anchorsetting} 
            open={Boolean(anchorsetting)} 
            onClose={settingMenuClose}
            PaperProps={{
              sx: {
                backgroundColor: 'var(--bg-card)',
                border: '1px solid var(--border-light)',
                boxShadow: 'var(--shadow-lg)',
                borderRadius: 'var(--radius-lg)',
                mt: 1
              }
            }}
          >
            <MenuItem 
              className='setting-menu-item' 
              onClick={() => {navigate('/Home/User-Management'); settingMenuClose();}}
            >
              <img src={userlock} alt="userlock" width="20" height="20"/>
              <span>User Management</span>
            </MenuItem>
            <MenuItem 
              className='setting-menu-item' 
              onClick={() => {navigate('/Home/Organization-Management'); settingMenuClose();}}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V20C20 20.5523 19.5523 21 19 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 7H15M9 11H15M9 15H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Organization Management</span>
            </MenuItem>
            <MenuItem
              className='setting-menu-item'
              onClick={() => {navigate('/Home/Banner-Management'); settingMenuClose();}}
            >
              <img src={templateBanner} alt="banner" width="20" height="20"/>
              <span>Banner Management</span>
            </MenuItem>
            <MenuItem
              className='setting-menu-item'
              onClick={() => {navigate('/Home/Review-Management'); settingMenuClose();}}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Review Management</span>
            </MenuItem>
          </Menu>
        </Drawer>
      </Box>
    </>
  );
};

export default Layout;
